.az{overflow:hidden;}